<script setup>
import {ref, onMounted, watch, computed, getCurrentInstance, toRaw, onBeforeUnmount, inject, defineExpose} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { usePageLoadingStore } from '../../../../../../stores/pageLoading'
import { useUserStore } from '../../../../stores/user'
import JobFairResumeDetailModal from '../../../../components/modal/jobFair/JobFairResumeDetailModal.vue'
import MyPageResumeApplicantListView from './MyPageResumeApplicantListView.vue'
import mypageJobFairResumeService from '../../../../services/mypage/jobFair/mypageJobFairResumeService'
import mypageJobFairService from "../../../../services/mypage/jobFair/mypageJobFairService";
import JobFairReusmeCreatePolicyModal from '../../../../components/modal/jobFair/JobFairReusmeCreatePolicyModal.vue';

const route = useRoute()
const router = useRouter()
const loadingStore = usePageLoadingStore()
const { user, isAuthenticated } = useUserStore()
const globals = getCurrentInstance().appContext.config.globalProperties;
const { $pageListBoardNo, alert, confirm } = globals;


const currentPage = ref(1);
const pageSize = ref(10);
const totalPages = ref(1);
const totalCount = ref(0);
const list = ref([]);

const currentPage2 = ref(1);
const pageSize2 = ref(10);
const totalPages2 = ref(1);
const totalCount2 = ref(0);
const applicantList = ref([]);

const pageSizeGroup = ref([
  { label:"10개씩 보기", value: 10 },
  { label:"30개씩 보기", value: 30 },
  { label:"50개씩 보기", value: 50 },
  { label:"100개씩 보기", value: 100 },
])

const isApplicantView = ref(false);
const selectedResumeId = ref('');
const selectedFileYn = ref('');
const hideFooterBtns = ref(false); // 하단 버튼 숨김 여부 추가

// 모달
const modalContent = ref([]);
const okButtonText = ref("확인");
const jobFairResumeModal = ref(null); // 이력서
const jobFairReusmeCreatePolicyModal = ref(null); // 정보제공 동의 여부

const onSelectPage = (pageNo) => {
  currentPage.value = pageNo;
  retrieveList();
}

// 페이지당 개수 변경
const onSelectPageSize = (option) => {
  pageSize.value = option.value;
  currentPage.value = 1;
  retrieveList();
}

const retrieveList = () => {
  let paramObj = {
    pageNumber: currentPage.value || 0,
    size: pageSize.value || 10,
  }

  loadingStore.loading = true;
  mypageJobFairResumeService.retrieveResumeListPaging(paramObj)
    .then( (res) => {
      if(res.data.code.toLowerCase() === 'success') {
        const result = res.data.result;
        // console.log(result);
        totalPages.value = result.totalPages;
        totalCount.value = result.totalElements;
        list.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
      }
      loadingStore.loading = false;
    })
    .catch( (error) =>  {
      loadingStore.loading = false;
    });
}

// 이력서 보기
const onClickMyResume = async (resume) => {
  const resumeId = resume.resumeId;
  const applicantCnt = resume.applicantCnt;
  const intvProposalCnt = resume.intvProposalCnt;
  const intvPropStateGb = resume.intvPropStateGb;

  let isHideFooterBtn = false;
  if (applicantCnt !== 0) {
    isHideFooterBtn = true;
  } else {
    isHideFooterBtn = false;
  }

  await jobFairResumeModal.value.show({
    resumeId,
    showDeleteBtn: applicantCnt === 0 && intvProposalCnt === 0 && (intvPropStateGb === null || intvPropStateGb === '01') || (intvPropStateGb === '02' || intvPropStateGb === '03'),
    hideFooterBtn: isHideFooterBtn,
   });

  retrieveList();
}

// 입사지원 수 클릭시
const onClickAppicantCnt = (resumeId, fileYn) => {
  isApplicantView.value = true;
  selectedResumeId.value = resumeId;
  selectedFileYn.value = fileYn;
}

// 인재정보 공개 여부
const onClickChangeResOpenYn = async (resume, resOpenYn) => {
  // 기존에 오픈된 이력서 존재 여부 확인. true/false
  let resumeY = 'N';
  if(resOpenYn === 'Y') {
    const result = await mypageJobFairResumeService.retrieveResumeResOpenYn(resume.userId);
    resumeY = result.data.result || 'N';
  }
  
  let ok = null;
  if(resumeY === 'Y') {
    ok = await confirm([
      "상시채용관 인재정보에 공개할 수 있는",
      "<span style='color:red;'>이력서는 1개만 가능</span>합니다.",
      "<br/>",
      "해당 이력서를 공개 하시겠습니까?",
      "<span style='color:red;'>나머지는 비공개 처리 됩니다.</span>"
    ], "인재정보 공개");
    if(!ok) {
      return;
    }
  }
  let resOpenYnName = resOpenYn === 'Y' ? '공개' : '비공개';
  if(ok === null) {
    if (resOpenYn === 'Y') {
      ok = await confirm([`해당 이력서를 ${resOpenYnName} 하시겠습니까?`], "인재정보 공개");
    } else {
      ok = await confirm([`해당 이력서를 ${resOpenYnName} 하시겠습니까?`], "예", "아니오");
    }
  }
  
  if (ok) {
    const paramObj = {
      resumeId: resume.resumeId,
      resOpenYn,
    };

    mypageJobFairResumeService.updateStatusResumeResOpenYn(paramObj)
      .then(async (res) => {
        loadingStore.loading = false;
        if (res.data.code.toLowerCase() === 'success') {
          alert(["선택한 이력서가", `상시채용관 인재정보에 ${resOpenYnName} 되었습니다.`]);
          retrieveList();
        } else {
          alert(["인재정보 공개 여부 변경이 정상적으로 이루어지지 않았습니다."]);
        }
      })
      .catch((error) => {
        loadingStore.loading = false;
        alert(["인재정보 공개 여부 변경이 정상적으로 이루어지지 않았습니다."]);
      }); 
  }
}

// 이력서 등록
const onClickResumeCreate = () => {
  const userId = user.userInfo.userCd;

  loadingStore.loading = false;
  mypageJobFairService.retrieveRecruitPrivacyAgreeYnByUserId(userId)
    .then( async (res) => {
      if(res.data.code.toLowerCase() === 'success') {
        const result = res.data.result;

        if (result !== 'Y') { // 개인정보 이용 동의 내역이 없을때
          const ok = await jobFairReusmeCreatePolicyModal.value.show();
          if(ok) {
            router.push({ name: 'MyPageJobFairResumeCreate'});
          }
        } else {
          router.push({ name: 'MyPageJobFairResumeCreate' });
        }
      }
    })
    .catch( (error) =>  {
      loadingStore.loading = false;
    });
}

// 이력서 수정
const onClickEditResume = (resumeId) => {
  router.push({ name: 'MyPageJobFairResume', query : { resumeId: resumeId, }})
}

// 이력서 삭제
const onClickDelete = async (resumeId, resOpenYn) => {
  if (resOpenYn === "Y") {
    modalContent.value = ["인재정보에 공개된 이력서 입니다.", "그래도 이력서를 삭제하시겠습니까?"];
  } else {
    modalContent.value = ["이력서를 삭제하시겠습니까?"];
  }
  
  const ok = await confirm(modalContent.value, "삭제");
  if(ok) {
    mypageJobFairResumeService.deleteResume({resumeId})
      .then((res) => {
        loadingStore.value = true;
        if(res.data.code.toLowerCase() === 'success') {
          if(resOpenYn === "Y") {
            alert(["이력서가 삭제되었습니다.", "인재정보에 공개할 이력서를 다시 선택하세요."]);
          } else {
            alert(["이력서가 삭제되었습니다."]);
          }
          retrieveList();
        } else {
          if (res.response.data.result.message) {
            alert([res.response.data.result.message]);
          } else {
            alert(["이력서 삭제가 정상적으로 이루어지지 않았습니다."]);
          }
        }
      })
      .catch( (res) =>  {
        loadingStore.loading = false;
        alert([res.response.data.result.message]);
      });
  }
}

onMounted(()=>{
  retrieveList();
});

</script>

<template>
  <div v-show="!isApplicantView">
    <div class="table-form">
        <div class="instructions mb-xs">
          <p>상시채용관 인재정보에 공개 할 수 있는 <span class="red">이력서는 1개만 가능</span>합니다.</p>
          <p><span class="red">입사지원한 이력서는 수정 및 삭제가 불가능</span>합니다.</p>
        </div>
        <div class="list-top mb-n-xs">
          <KSAPrimaryButton text="이력서 등록" @click="onClickResumeCreate()" />
        </div>
        <div class="list-top">
          <p>총 <span>{{ $number(totalCount)}}</span>개</p>
          <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
        </div>
        <div class="table-form">
          <table class="table-form board-mobile-vertical" v-if="list !== null">
            <tr>
              <th>번호</th>
              <th>내 이력서 제목</th>
              <th>입사지원</th>
              <th>최근 수정일</th>
              <th>등록일</th>
              <th>관리</th>
              <th>인재정보 공개</th>
            </tr>
            <tr v-for="resume in list">
              <td>{{ resume.boardNo }}</td>
              <td>
                <p class="text-overflow long-overflow" v-if="resume.fileYn === 'Y'" v-for="eduHist in resume.resumeAttaches">
                  <KSATextButton :text="resume.title" @click="$downloadForPrivate({fileName:eduHist.fileName, fileDir: eduHist.fileDir })" />
                </p>
                <p v-else class="clickable blue text-overflow long-overflow" @click="onClickMyResume(resume)">
                  {{ resume.title }}
                </p>
              </td>
              <td class="clickable blue" @click="onClickAppicantCnt(resume.resumeId, resume.fileYn)">{{ resume.applicantCnt }}</td>
              <td>{{ $yyyymmddHHmmss(resume.modifyDate) }}</td>
              <td>{{ $yyyymmddHHmmss(resume.createDate) }}</td>
              <td>
                <!-- 면접제안을 수락/거절했을 경우 수정 불가, 삭제 불가 -->
                <div v-if="resume.applicantCnt === 0">
                    <KSATextButton class="clickable mr-xs" text="수정" @click="onClickEditResume(resume.resumeId)"/>
                    <KSATextButton class="clickable red_button" text="삭제" @click="onClickDelete(resume.resumeId, resume.resOpenYn)"/>
                </div>
                <div v-else>-</div>
              </td>
              <td>
                <div v-if="resume.fileYn !== 'Y'">
                  <span v-if="resume.resOpenYn === 'Y'">
                    <img src="../../../../../../assets/images/toggle_on.png" @click="onClickChangeResOpenYn(resume, 'N')" style="cursor:pointer;" />
                  </span>
                  <span v-else>
                    <img src="../../../../../../assets/images/toggle_off.png" @click="onClickChangeResOpenYn(resume, 'Y')" style="cursor:pointer;" />
                  </span>
                </div>
                <div v-else>-</div>
              </td>
            </tr>
          </table>
        </div>
        <div class="result-none lecture-none" v-if="list.length === 0">
          등록된 이력서가 없습니다.
        </div>
        <Paginate
            v-if="list.length > 0"
            v-model="currentPage"
            :page-count="totalPages"
            :click-handler="onSelectPage"
        />
      </div>
  </div>
  <div v-show="isApplicantView">
    <MyPageResumeApplicantListView
      :resume-id="selectedResumeId"
      :file-yn="selectedFileYn"
      @go-back="isApplicantView = false;"
    />
  </div>
  <JobFairResumeDetailModal ref="jobFairResumeModal" /> <!-- 특별채용관 이력서 상세 -->
  <JobFairReusmeCreatePolicyModal ref="jobFairReusmeCreatePolicyModal" />
</template>

<style lang="scss" scoped>
@import "../../../../../../assets/scss/theme";

.instructions {
  background: $gray-regular_color;
  padding: 20px;
  p {
    &:before {
      content: "ㆍ";
    }
    .red {
      display: inline-block;
      color: $red_color;
    }
  }
}

</style>
